import _ from 'lodash';
import template from './ptzCircles.html';

/* @ngInject */
function PTZCirclesController($scope, $element) {
  const vm = this;

  const defaultPanTilt = {
    minPan: -180,
    maxPan: 180,
    minTilt: -90,
    maxTilt: 20
  };
  const circles = {
    tilt: {
      name: 'tilt',
      x: 0,
      y: -0.5,
      elements: {
        circle: '#tilt-circle',
        arrow: '#tilt-arrow',
        degree: '#tilt-degrees'
      }
    },
    pan: {
      name: 'pan',
      x: 0,
      y: 0.5,
      elements: {
        circle: '#pan-circle',
        arrow: '#pan-arrow',
        degree: '#pan-degrees'
      }
    }
  };
  const rotateCirclebyFrame = requestMemoizedAnimFrame();

  const initialization = {
    limits: false
  };

  const svgs = {
    tiltSvg: null,
    panSvg: null
  };
  const pts = {
    tiltPt: null,
    panPt: null
  };

  let pan;
  let tilt;

  let minPan;
  let maxPan;
  let minTilt;
  let maxTilt;
  let tiltDeduction;
  let panDeduction;

  let rotatingCircle;

  vm.stopPtzLoader = false;

  vm.$postLink = postLink;
  vm.$onChanges = onChanges;
  vm.$onDestroy = destroy;

  function postLink() {
    const svgWatcher = $scope.$watch(() => $('.ptz-rotate', $element).length, (newV) => {
      if (newV === 2) {
        svgWatcher();
        svgs.tiltSvg = $('#tilt-svg', $element)[0];
        svgs.panSvg = $('#pan-svg', $element)[0];
        pts.tiltPt = svgs.tiltSvg.createSVGPoint();
        pts.panPt = svgs.panSvg.createSVGPoint();

        fetchDOMObjects();

        circles.tilt.elements.arrow.on('click touchstart', evt => activatePanTiltRotate(evt, 'tilt'));
        circles.pan.elements.arrow.on('click touchstart', evt => activatePanTiltRotate(evt, 'pan'));

        $('body').on('mousemove touchmove', rotateOnMousemove);
      }
    });
  }

  function onChanges(changes) {
    if (_.has(changes, 'info.currentValue') &&
      _.get(changes, 'info.currentValue', 'N/A') !== changes.info.previousValue) {
      initializePanTiltAndDeductions(vm.info);

      if (!_.isString(circles.tilt.elements.circle)) {
        alterCSSAndText('tilt', tilt * -1, null, tilt === 0 ? 0 : tilt.toFixed(2));
        alterCSSAndText('pan', pan, null, pan === 0 ? 0 : pan.toFixed(2));
      }

      initialization.info = true;
      vm.stopPtzLoader = true;
    }

    if (!initialization.limits && _.has(changes, 'limits.currentValue') &&
      _.get(changes, 'limits.currentValue', 'N/A') !== changes.limits.previousValue) {
      initializeLimits();
      rotateCirclebyFrame(initializeDegrees);
      initialization.limits = true;
    }
  }

  function destroy() {
    $('body').off('mousemove touchmove', rotateOnMousemove);
    $('body').off('mouseup touchend', deactivateRotate);
  }

  /**
   * This fetches the DOM elements using the keys from the elements objects of both the tilt and pan circles.
   *
   * @returns {undefined}
   */
  function fetchDOMObjects() {
    _.forEach(circles.tilt.elements, (selector, key, col) => {
      col[key] = $(selector, $element);
    });
    _.forEach(circles.pan.elements, (selector, key, col) => {
      col[key] = $(selector, $element);
    });
  }

  /**
   * Converts the raw pan and tilt into valid integers then determines the amount of deduction to apply to both.
   *
   * @param {object} info - Initialization values
   * @param {number} info.pan - Amount to pan
   * @param {number} info.tilt - Amount to tilt
   *
   * @returns {undefined}
   */
  function initializePanTiltAndDeductions(info) {
    pan = getValidInteger(info.pan, 0);
    tilt = getValidInteger(info.tilt, 0);

    // The range for pan is usually larger than the tilt's range, deducting 2 at a time makes more sense so that
    // it doesn't take too long to finish
    tiltDeduction = tilt * -1 < 0 ? -1 : 1;
    panDeduction = pan < 0 ? -2 : 2; // eslint-disable-line no-magic-numbers
  }

  /**
   * Extracts the pan/tilt limits from the limits binding.
   *
   * @returns {undefined}
   */
  function initializeLimits() {
    try {
      minPan = getValidInteger(vm.limits.minPan, defaultPanTilt.minPan);
      maxPan = getValidInteger(vm.limits.maxPan, defaultPanTilt.maxPan);
      minTilt = getValidInteger(vm.limits.minTilt, defaultPanTilt.minTilt);
      maxTilt = getValidInteger(vm.limits.maxTilt, defaultPanTilt.maxTilt);
    } catch (err) {
      throw new Error('Error establishing limits: ', err);
    }
  }

  /**
   * Parses an integer or supplies the defaultVal
   *
   * @param {string|number} value - value to parse
   * @param {number} defaultVal - fallback if value is infinite
   *
   * @returns {number} parsed integer or defaultVal
   */
  function getValidInteger(value, defaultVal) {
    const parsed = parseInt(value, 10);
    return _.isFinite(parsed) ? parsed : defaultVal;
  }

  // TODO: add to universal utils service
  /**
   * Memoizes a variable and returns a function that assigns, and can be called again to cancel, a
   * requestAnimationFrame that calls the initializeDegrees method with any supplied arguments.
   *
   * @returns {number} a requestAnimationFrame ID
   */
  function requestMemoizedAnimFrame() {
    let initialAnimation;

    return (method, ...args) => {
      if (method === 'cancel' && initialAnimation) {
        return window.cancelAnimationFrame(initialAnimation);
      }
      initialAnimation = window.requestAnimationFrame(() => initializeDegrees(...args));
      return initialAnimation;
    };
  }

  /**
   * Used in combination with the requestAnimationFrame, this increments both the tilt and pan of a circle by small
   * degrees until they both match the actual tilt and pan supplied by the info binding.
   *
   * @param {number} [tiltAmt]
   * @param {number} [panAmt]
   * @returns {undefined} calls itself repeatedly until canceling with the tiltAmt/panAmt match the info.pan/info.tilt
   */
  function initializeDegrees(tiltAmt = 0, panAmt = 0) {
    if (Math.abs(tilt) - Math.abs(tiltAmt * -1) > 1) {
      alterCSSAndText('tilt', tiltAmt, null, tiltAmt * -1);
      tiltAmt += tiltDeduction;
    } else {
      alterCSSAndText('tilt', tilt * -1, null, tilt === 0 ? 0 : tilt.toFixed(2));
      tiltAmt = tilt;
    }

    if (Math.abs(pan) - Math.abs(panAmt) > 2) {
      alterCSSAndText('pan', panAmt, null, panAmt);
      panAmt += panDeduction;
    } else {
      alterCSSAndText('pan', pan, null, pan === 0 ? 0 : pan.toFixed(2));
      panAmt = pan;
    }

    if (tiltAmt !== tilt || panAmt !== pan) {
      // TODO: when not 'cancel'ing, there is likely no need to pass an argument like this to the first parameter
      return rotateCirclebyFrame(initializeDegrees, tiltAmt, panAmt);
    }
    return rotateCirclebyFrame('cancel');

  }

  /**
   * On click/touchstart, activates rotation of specified circle and assigns deactivate method to body element
   *
   * @param {Event} evt - Event
   * @param {string} circle - either 'tilt' or 'pan'
   *
   * @returns {undefined}
   */
  function activatePanTiltRotate(evt, circle) {
    evt.stopPropagation();
    evt.preventDefault();
    rotatingCircle = circles[circle];
    $('body').on('mouseup touchend', deactivateRotate);
  }

  /**
   * On mousemove,  calculates the circle and pans or tilts by that much.
   *
   * @param {Event} evt
   * @returns {undefined}
   */
  function rotateOnMousemove(evt) {
    evt.stopPropagation();
    if (rotatingCircle) {
      const { x, y } = cursorPoint(evt, svgs[`${rotatingCircle.name}Svg`], pts[`${rotatingCircle.name}Pt`]);
      const angle = calculateAngle(y, x);

      if (rotatingCircle.name === 'tilt') {
        rotateTiltCircle(angle);
      } else {
        rotatePanCircle(angle);
      }
    }
  }

  /**
   * Updates tilt value while validating that it stays within its max/min tilt. Also updates css and text of circle.
   *
   * @param {number} angle - Degrees to tilt
   *
   * @returns {undefined}
   */
  function rotateTiltCircle(angle) {
    let degreeAmt;
    let arrowColor;

    tilt = angle * -1;

    if (angle > 180) {
      // 360 must be added in order to stay within a viable range
      tilt += 360;
    }

    if (tilt <= maxTilt && tilt >= minTilt) {
      degreeAmt = angle;
      arrowColor = 'green';
    } else if (tilt > maxTilt) {
      degreeAmt = maxTilt * -1;
      tilt = maxTilt;
    } else {
      degreeAmt = minTilt * -1;
      tilt = minTilt;
    }

    alterCSSAndText('tilt', degreeAmt, arrowColor || 'red', tilt.toFixed(2));
  }

  /**
   * Updates pan value while validating that it stays within its max/min pan. Also updates css and text of circle.
   *
   * @param {number} angle - Degrees to pan
   *
   * @returns {undefined}
   */
  function rotatePanCircle(angle) {
    let arrowColor;

    pan = angle;

    if (angle > 180) {
      // 360 must be deducted in order to stay within a viable range
      pan -= 360;
    }

    if (pan <= maxPan && pan >= minPan) {
      arrowColor = 'green';
    } else if (pan > maxPan) {
      pan = maxPan;
    } else {
      pan = minPan;
    }

    alterCSSAndText('pan', pan, arrowColor || 'red', pan.toFixed(2));
  }

  /**
   * Uses the updated pan/tilt values to transform - rotate the circle, updates its arrow color, and display the
   * current pan/tilt values.
   *
   * @param {string} circleType - Transformation type: either 'tilt' or 'pan'
   * @param {number} degreeAmt - Degrees of transformation
   * @param {string} fillColor - Color to assign to the circle's arrow
   * @param {string} text - the tilt/pan amount displayed on the circle
   *
   * @returns {undefined}
   */
  function alterCSSAndText(circleType, degreeAmt, fillColor, text) {
    const elements = circles[circleType].elements;
    if (degreeAmt) {
      $(elements.circle).attr('transform', `rotate(${degreeAmt})`);
    }

    if (text) {
      elements.degree.text(`${text}\u{000B0}`);
    }

    if (fillColor) {
      elements.arrow.css('fill', fillColor);
    }

  }

  /**
   * on mouseup, deactivates the rotate, calls the method supplied through the absolutesCallback binding, and
   * removes the body click listener.
   *
   * @returns {undefined}
   */
  function deactivateRotate() {
    if (rotatingCircle) {
      circles[rotatingCircle.name].elements.arrow.css('fill', 'black');
    }
    if (rotatingCircle && vm.absolutesCallback) {
      vm.absolutesCallback(pan, tilt);
    }
    $('body').off('click touchstart');
    rotatingCircle = null;
  }

  function cursorPoint(evt, svg, pt) {
    if (_.isNumber(evt.clientX)) {
      pt.x = evt.clientX;
      pt.y = evt.clientY;
    } else {
      pt.x = evt.originalEvent.changedTouches[0].clientX;
      pt.y = evt.originalEvent.changedTouches[0].clientY;
    }

    return pt.matrixTransform(svg.getScreenCTM().inverse());
  }

  function calculateAngle(x, y) {
    const originAngle = Math.abs(y) / Math.abs(x); // The angle that the line [(0,0);(x,y)] forms with the x-axis
    let angle = Math.atan(originAngle) * 180 / Math.PI;
    if (y * x > 0) {
      angle = 90 - angle + (y < 0 ? 180 : 0);
    } else {
      angle += y < 0 ? 90 : 270; // eslint-disable-line no-magic-numbers
    }
    return angle;
  }
}

export default {
  name: 'ptzCircles',
  template,
  controller: PTZCirclesController,
  bindings: {
    limits: '<',
    info: '<',
    absolutesCallback: '<'
  }
};
